import React from 'react';
import { useDispatch } from 'react-redux';
import BasicPageHOC from 'src/constrains/SalesChannelPreviewPageComponents/SalesChannelContentBasicPageHOC';
//import { useParams } from 'react-router-dom';
import PageWrapper from 'src/constrains/SalesChannelPreviewPageComponents/PageWrapper/PageWrapper';
import RightConfigWrapper from 'src/constrains/SalesChannelPreviewPageComponents/RightConfigWrapper';
import { convertDataFromReduxToServer } from 'src/pages/SalesChannelContentEditor/SalesChannelFooter/tools';
import { dispatch } from 'src/store';
import {
  fetchFooter,
  fetchFooterRequiredInfo,
  getCollapseValidationMsgDisplay,
  getHasModified,
  getLoaded,
  getSalesChannel,
  getSalesChannelName,
  getState,
  resetData,
  //submitContentHomepage,  submitContentShoppingCart,
  submitFooter,
  validation,
} from './slice';

import FooterMenu from './FooterMenu';
import FooterNote from './FooterNote';
import FooterStyle from './FooterStyle';
import CurrencySelector from './CurrencySelector';
import LanguageSelector from './LanguageSelector';
import LocationSelector from './LocationSelector';
import SocialMedia from './SocialMedia';

import { PreviewStyleSwitch } from '@/src/constrains/SalesChannelPreviewPageComponents/PreviewContainer';
import { useI18n } from 'src/hooks/useRouterChange';
import { i18nGet } from 'src/tools/tools';
const SalesChannelEditorFooterPage = (props) => {
  const i18n = useI18n();
  const getI18n = (str) => i18nGet(i18n, str);
  const {
    onDiscard,
    onGoBack,
    submitData,
    hasModified,
    salesChannel,
    salesChannelName,
    loaded: _loaded,
    isOnPrimaryLanguage,
    currentStyle,
    // currentStyle,
  } = props;
  const hideRightPart = true;
  //console.log('currentStyle', currentStyle);
  const _d = useDispatch();
  //const _params: IParams = useParams();
  React.useEffect(() => {
    return () => {
      _d(resetData());
    };
  }, []);

  const _rightChild = (
    <RightConfigWrapper
      wrapperClassName={hideRightPart ? 'wrapperWithoutLeft' : ''}
      title={getI18n('general.sider.footer')}
      elements={[
        {
          body: (
            <React.Fragment>
              {isOnPrimaryLanguage && (
                <FooterStyle collapseOpenDefault={hideRightPart} />
              )}
              <LocationSelector
                isPrimary={isOnPrimaryLanguage}
                collapseOpenDefault={hideRightPart}
              />
              <LanguageSelector
                isPrimary={isOnPrimaryLanguage}
                collapseOpenDefault={hideRightPart}
              />
              <CurrencySelector
                isPrimary={isOnPrimaryLanguage}
                collapseOpenDefault={hideRightPart}
              />
              <SocialMedia
                isPrimary={isOnPrimaryLanguage}
                collapseOpenDefault={hideRightPart}
              />
              <FooterMenu
                isPrimary={isOnPrimaryLanguage}
                collapseOpenDefault={hideRightPart}
              />
              <FooterNote
                isPrimary={isOnPrimaryLanguage}
                collapseOpenDefault={hideRightPart}
              />
            </React.Fragment>
          ),
          key: 'rightTop',
        },
      ]}
    />
  );
  const _leftChild = (
    <PreviewStyleSwitch
      style={currentStyle}
      styleChild={
        <div
          style={{
            height: 10000,
            backgroundColor: 'transparent',
            // margin: '0 auto',
          }}>
          123
        </div>
      }
      normalChild={<div>312</div>}
    />
  );
  const leftChild = hideRightPart ? _rightChild : _leftChild;
  const rightChild = hideRightPart ? null : _rightChild;
  return (
    <React.Fragment>
      {_loaded && (
        <PageWrapper
          headerConfig={{
            hasModified,
            submit: submitData,
            salesChannelContentData: salesChannel || {},
            salesChannelName,
            onDiscard,
            onGoBack,
            // hasStyleSelect: true,
          }}
          hideRightPart={hideRightPart}
          withoutCollapse={hideRightPart}
          leftChild={leftChild}
          rightChild={rightChild}
        />
      )}
    </React.Fragment>
  );
};
export default BasicPageHOC(SalesChannelEditorFooterPage, {
  // siteStyleInParams: true,
  previewSizeInParams: true,
  getState,
  convertDataFromReduxToServer,
  submit: submitFooter,
  getHasModified,
  getSalesChannel,
  getSalesChannelName,
  getLoaded,
  getErrorDisplay: getCollapseValidationMsgDisplay,
  validation,
  queryData: (params, qParams) => {
    const { contentUuid } = params;
    dispatch(
      fetchFooter({
        uuid: contentUuid,
        params: qParams,
      }),
    );
    dispatch(
      fetchFooterRequiredInfo({
        uuid: contentUuid,
      }),
    );
  },
});
